var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeShow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a6acb8",
    fillRule: "evenodd",
    transform: "translate(1.5 9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.544C6.685 4.848 13.883 0 21.595 0S36.83 4.848 44.163 14.544c-6.91 9.761-14.27 14.642-22.082 14.642-7.811 0-15.172-4.88-22.081-14.642zm21.74 10.51c5.722 0 10.36-4.638 10.36-10.36 0-5.723-4.638-10.362-10.36-10.362-5.723 0-10.362 4.639-10.362 10.361 0 5.723 4.639 10.362 10.361 10.362z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.779,
    cy: 14.775,
    r: 4.507
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShow);
export default __webpack_public_path__ + "static/media/eye-show.62accfcf43e7274241b5235a9cdac2dc.svg";
export { ForwardRef as ReactComponent };